import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import { reviewActions } from '../../store/review-slice';
import { Checkbox } from '@mui/material';
import AuthContext from '../../store/auth-context';

import './BillingGridMatrix.scss';
import BillingGridAddRow from './BillingGridAddRow';
import { debounce } from 'lodash';
import { addPIComment } from '../../api/userReviewAPI';

function createMatrix(billingGridJson) {
	const rows = billingGridJson.row_M;
	const columns = billingGridJson.column_M;
	// generate an array with dimensions row_M x colums_M
	const matrix = Array(rows)
		.fill()
		.map(() => Array(columns).fill());

	let linearMatrixData = [];

	// map the JSON information into a linear array
	billingGridJson.data.forEach((e) => {
		// data is just a single point
		linearMatrixData.push({
			value: e.Label,
			row: e.Coordinates.row,
			column: e.Coordinates.column,
			rowSpan: 1,
			columnSpan: 1,
			checkbox: e.checkbox || false,
			comment: e.comment || false,
			edited: e.edited || false,
			header: e.headers || false
		});
	});
	//map the linear array into the generated matrix
	linearMatrixData.forEach((lmd) => {
		matrix[lmd.row][lmd.column] = {
			...lmd
		};
	});
	return matrix;
}

const BillingGridBuilder = ({
	onRequestReview,
	billingGridData,
	tableNumber,
	studyId,
	studyStatus
}) => {
	const dispatch = useDispatch();
	const authCtx = useContext(AuthContext);
	const additionalInfo = billingGridData.addInfo
		? billingGridData.addInfo
		: false;
	// function that creates a matrix from JSON information
	const generatedMatrix = createMatrix(billingGridData);

	const onChangeCheck = (
		checked,
		selectedField,
		row,
		column
	) => {
		if (checked) {
			// store the coordinate of the item that the user selects
			dispatch(reviewActions.setActivePoint([row, column]));
			dispatch(reviewActions.setTableIndex(tableNumber));
			dispatch(reviewActions.setOldValue(selectedField));
		}
		// store the comment or value of the item selected
		dispatch(
			reviewActions.setElement({
				value: selectedField,
				row,
				column,
				checked
			})
		);
	};
	const onChangeAddComment = debounce(
		(value, row, column) => {
			// store the comment or value of the item selected
			const addCommentObj = {
				studyId: studyId,
				index: tableNumber,
				coordinates: {
					row,
					column
				},
				comment: value
			};
			addPIComment(addCommentObj)
				.then((result) => {
					console.log(result);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		500
	);

	return (
		<>
			<div className='billing-grid-table-container'>
				{' '}
				{additionalInfo && (
					<span>Additional Information</span>
				)}
				<table className='table table-bordered'>
					<tbody>
						{generatedMatrix.map((row, i) => {
							return (
								<tr key={i}>
									{row.map((e, j) => {
										return (
											<td
												key={j}
												colSpan={e?.columnSpan}
												rowSpan={e?.rowSpan}
												className={`table-cell td-billing-grid-default ${
													e.edited === true
														? ' edited-field'
														: ''
												}${
													e?.column === 0
														? ' sticky-field'
														: ''
												}${
													e.header === true
														? ' header-field'
														: ''
												}`}
											>
												{e.value === 'nan' ||
												e.comment === true
													? ''
													: e.value}
												{e.comment === true && (
													<input
														className='form-control review-comment-input'
														type='text'
														defaultValue={
															e.value !== 'nan'
																? e.value
																: ''
														}
														disabled={
															authCtx.userData.role === 'QA'
																? false
																: true
														}
														onChange={(event) =>
															onChangeAddComment(
																event.target.value,
																e.row,
																e.column
															)
														}
													/>
												)}
												{e.checkbox === true &&
													onRequestReview && (
														<Checkbox
															size='small'
															onChange={(event) =>
																onChangeCheck(
																	event.target.checked,
																	e.value,
																	e.row,
																	e.column
																)
															}
														/>
													)}
											</td>
										);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			{!additionalInfo && (
				<BillingGridAddRow
					tableNumber={tableNumber}
					studyId={studyId}
					studyStatus={studyStatus}
				/>
			)}
		</>
	);
};

export default BillingGridBuilder;
